// extracted by mini-css-extract-plugin
export default {"backward":"back-button_backward__xym6+"};